// @flow
import React, {Component} from 'react';
import {View} from 'react-native';
import {Touchable} from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import DoughnutWithContentAndFill from '../../common/DoughnutWithContentAndFill';
import TopUpDoughnutLegend from './TopUpDoughnutLegend';
import theme, {getUsageStyle} from '../../../theme-config';

export default class TopUpDoughnut extends Component<Props, *> {
  render() {
    const {size, label, isActive, unitType, onPress, current, endDateTime} =
      this.props;
    const {borderColor, iconColor, textColor} = getUsageStyle(label, theme);
    const doughnutWithContentAndFillProps = {
      isActive,
      label,
      size,
      borderColor,
      iconColor,
      textColor,
    };
    const legendProps = {
      current,
      isActive,
      unitType,
      endDate:
        endDateTime && I18n.l('date.formats.short', new Date(endDateTime)),
    };

    return (
      <View style={this.props.style}>
        <Touchable
          borderRadius={size / 2}
          onPress={typeof onPress === 'function' ? onPress : null}>
          <View>
            <DoughnutWithContentAndFill {...doughnutWithContentAndFillProps} />
          </View>
        </Touchable>
        <TopUpDoughnutLegend {...legendProps} />
      </View>
    );
  }
}

type Props = {
  isActive: boolean,
  current: number,
  label: string,
  size: number,
  onPress?: Function,
  endDateTime: number,
  unitType: string,
  style?: any,
};
